module.exports = __webpack_public_path__ + "static/desktop_background-cce0efd5b6a5a5fad2bcd92b80269c10.jpg";